var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('AlertBanner'),_c('TheHeader',{attrs:{"headerTop":_vm.headerTop}}),_c('TheSidebar',{attrs:{"headerTop":_vm.headerTop}}),_c('main',{staticClass:"main-container",style:({ top: _vm.subHeaderTop })},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }